import { useState, useEffect } from 'react';

export const useIsMimicking = () => {
  const [isMimicking, setIsMimicking] = useState(false);

  useEffect(() => {
    const checkMimicState = () => {
      const originalToken = localStorage.getItem('originalAdminToken');
      const mimickedUserData = localStorage.getItem('mimickedUser');
      setIsMimicking(!!originalToken && !!mimickedUserData);
    };

    checkMimicState();
    window.addEventListener('storage', checkMimicState);
    return () => window.removeEventListener('storage', checkMimicState);
  }, []);

  return isMimicking;
};
